var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DeleteAccountListCard',{attrs:{"search":_vm.search,"deletionAccounts":{}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }